import { BsCheckCircleFill } from "react-icons/bs"
import { AppSpan, CustomContainer, FlexColumn, FlexRow } from "src/style"

interface PasswordRequirementRule {
    key: string
    label: string
    passed: boolean
}

interface PasswordRequirementsProps {
    title?: string
    rules: PasswordRequirementRule[]
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ title, rules }) => {
    return (
        <CustomContainer
            radius='0.8' bgColor='#E7F6F5'
            padding='1.2' topPadding='1.2' topMargin='1.2'
        >
            {title &&
                <AppSpan textSize='1.3' fontWeight='700' color='#0A756F' bottomPadding='0.6'>
                    {title}
                </AppSpan>
            }
            <FlexColumn alignItems='flex-start'>
                {rules.map((rule, index) => (
                    <FlexRow
                        key={rule.key}
                        alignItems='center'
                        topMargin={index === 0 ? '' : '0.6'}
                        style={{ gap: '0.6rem' }}
                    >
                        <BsCheckCircleFill
                            style={{
                                fontSize: '1.4rem',
                                color: rule.passed ? '#0D968F' : '#98A2B3'
                            }}
                        />
                        <AppSpan textSize='1.3' color='#344054'>
                            {rule.label}
                        </AppSpan>
                    </FlexRow>
                ))}
            </FlexColumn>
        </CustomContainer>
    )
}
